import { useAlert } from "hooks/alerts/useAlert";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "services/api.service";
import { AssetRetrievalDevice } from "types/assetRetrieval";

export default function useAssetRetrievalDevices() {
  const [assetRetrievalDevices, setAssetRetrievalDevices] = useState<AssetRetrievalDevice[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const [totalPages, setTotalPages] = useState<number>(0);
  const [count, setCount] = useState<number>(0);
  const { alertSuccess, alertError } = useAlert();

  const getAssetRetrievalDevices = useCallback(() => {
    api.get(`/asset_retrieval_devices?${searchParams.toString()}`).then(({ data }) => {
      setAssetRetrievalDevices(data.assetRetrievalDevices);
      setLoading(false);
      setTotalPages(data.meta.totalPages);
      setCount(data.meta.count);
    });
  }, [searchParams]);

  useEffect(() => {
    getAssetRetrievalDevices();
  }, [getAssetRetrievalDevices, searchParams]);

  const toggleRemindersMute = useCallback(
    (asset_retrieval_uuid: any) => {
      return api
        .put(`asset_retrievals/${asset_retrieval_uuid}/mute_reminders`)
        .then(() => {
          alertSuccess("Successfully saved your preference.");
          getAssetRetrievalDevices();
        })
        .catch(() => {
          alertError("Something went wrong, please try again.");
        });
    },
    [alertError, alertSuccess, getAssetRetrievalDevices]
  );

  const exportAssetRetrievalDevices = useCallback(() => {
    api
      .get(`/asset_retrieval_devices/export_csv?${searchParams.toString()}`)
      .then(() => {
        alertSuccess("The export file will be sent to your email shortly.");
      })
      .catch(() => {
        alertError("Something went wrong, please try again later.");
      });
  }, [searchParams]);

  return {
    assetRetrievalDevices,
    loading,
    totalPages,
    count,
    searchParams,
    setSearchParams,
    getAssetRetrievalDevices,
    toggleRemindersMute,
    exportAssetRetrievalDevices,
  };
}
